'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            is_open: false
        };
    },

    props: ['description', 'class', 'readMore']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<article class=\"object-description\" :class=\"[class, {'object-description--open': is_open}]\">\n    <div class=\"object-description__content\">\n        {{{ description }}}\n    </div>\n    <a class=\"link\" @click=\"is_open=!is_open\" v-show=\"!is_open\">{{ readMore }}</a>\n</article>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4e648b4d", module.exports)
  } else {
    hotAPI.update("_v-4e648b4d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}